import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCalendar = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M16.958 0c.599 0 1.084.476 1.084 1.063V2.43h1.395C21.405 2.43 23 3.995 23 5.924v14.582C23 22.436 21.405 24 19.437 24H4.563C2.595 24 1 22.436 1 20.506V5.925c0-1.93 1.595-3.495 3.563-3.495h1.395V1.063C5.958.476 6.443 0 7.042 0c.6 0 1.085.476 1.085 1.063V2.43h7.746V1.063C15.873.476 16.36 0 16.958 0Zm3.873 5.924v3.798H3.169V5.924c0-.755.624-1.367 1.394-1.367h1.395v1.367c0 .587.485 1.063 1.084 1.063.6 0 1.085-.476 1.085-1.063V4.557h7.746v1.367c0 .587.486 1.063 1.085 1.063s1.084-.476 1.084-1.063V4.557h1.395c.77 0 1.394.612 1.394 1.367Zm0 5.924H3.169v8.658c0 .755.624 1.367 1.394 1.367h14.874c.77 0 1.394-.612 1.394-1.367v-8.658ZM7.042 14.582c-.599 0-1.084.476-1.084 1.064v2.43c0 .587.485 1.063 1.084 1.063h2.48c.598 0 1.084-.476 1.084-1.063v-2.43c0-.588-.486-1.064-1.085-1.064H7.042Zm1.085 2.43v-.303h.31v.304h-.31Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCalendar);
export default ForwardRef;
